import { Button, Input, Switch } from '@heroui/react'
import { FiPlus, FiRefreshCw, FiSearch } from 'react-icons/fi'

export default function BlockedNumbersFilters({
  searchTerm = '',
  onSearchChange,
  showActiveOnly = true,
  onActiveToggle,
  onRefresh,
  onAdd,
  isLoading = false,
  hasUnsavedChanges,
}) {
  return (
    <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
      <div className="flex items-center gap-2">
        <div className="relative">
          <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} />
          <Input
            placeholder="Search blocked numbers..."
            value={searchTerm}
            onChange={e => onSearchChange(e.target.value)}
            className="pl-10 w-80"
            size="sm"
            variant="bordered"
            radius="none"
          />
        </div>
        <Button
          isIconOnly
          variant="bordered"
          size="sm"
          onPress={onRefresh}
          isLoading={isLoading}
          radius="none"
        >
          <FiRefreshCw size={16} />
        </Button>
      </div>

      <div className="flex items-center gap-3">
        <Switch
          size="sm"
          isSelected={showActiveOnly}
          onValueChange={onActiveToggle}
        >
          Active only
        </Switch>
        <Button
          color="primary"
          size="sm"
          startContent={<FiPlus size={16} />}
          onPress={onAdd}
          radius="none"
          isDisabled={hasUnsavedChanges}
          title={hasUnsavedChanges ? 'Save current changes before adding new blocks' : undefined}
        >
          Add Block Rule
        </Button>
      </div>
    </div>
  )
}
